export default {"src":"/_next/static/media/realmem.670d2b87.svg","height":64,"width":64};